var _circle, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTubingnonCompliant(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.07,
    cy: 24.047,
    r: 1.535,
    fill: "#006FAC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.125,
    y: 27.076,
    width: 2.395,
    height: 5.389,
    rx: 1.198,
    transform: "rotate(-47.622 26.125 27.076)",
    fill: "#006FAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.375 22c0 6.834-5.54 12.375-12.375 12.375S9.625 28.835 9.625 22 15.165 9.625 22 9.625c6.834 0 12.375 5.54 12.375 12.375zM44 22c0 12.15-9.85 22-22 22S0 34.15 0 22 9.85 0 22 0s22 9.85 22 22zM7.73 31.846c-4.196-6.173-4.187-14.064-.624-19.779 3.535-5.667 10.636-9.29 20.87-6.794l.326-1.336C17.56 1.317 9.824 5.11 5.94 11.34 2.085 17.52 2.094 26 6.594 32.62l1.137-.774z",
    fill: "#006FAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubingnonCompliant);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='25.0697' cy='24.0466' r='1.53488' fill='%23006FAC'/%3e %3crect x='26.125' y='27.0762' width='2.39504' height='5.38884' rx='1.19752' transform='rotate(-47.6224 26.125 27.0762)' fill='%23006FAC'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M34.375 22C34.375 28.8345 28.8345 34.375 22 34.375C15.1655 34.375 9.625 28.8345 9.625 22C9.625 15.1655 15.1655 9.625 22 9.625C28.8345 9.625 34.375 15.1655 34.375 22ZM44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22ZM7.73086 31.8459C3.53375 25.6734 3.54256 17.7815 7.10631 12.0672C10.6406 6.40008 17.7418 2.7763 27.9762 5.27251L28.302 3.93667C17.5597 1.31657 9.82384 5.11132 5.9396 11.3396C2.08483 17.5205 2.09363 26.0008 6.59381 32.6191L7.73086 31.8459Z' fill='%23006FAC'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };